import { Factory } from '../Factory';
import { Service } from '../Service';
import { Status } from '../../model/project/Status';

export class ProjectService extends Service<any> {
  private currentProject: any;
  private httpService: any;
  private configService: any;

  constructor(resource: any, rootScope: IRootScope, configService: any, resourceWrapperService: any, httpService: any, private collectionService: any) {
    super({resource, rootScope, resourceWrapperService});

    this.httpService = httpService;
    this.configService = configService;

    let projectResource = this.resource(`${configService.getServerBaseUrlForResource()}/project/:id`,
      {id: "@id"}, {update: {method: "PUT"}}
    );

    this.itemResource = this.resourceWrapperService.WrapActions(projectResource);

    rootScope.$on('clearCurrentSelected', () => this.ClearCurrentProject());

    rootScope.$on(EVENTS.LOGIN_REQUIRED, () => this.ClearCurrentProject());
  }

  public Hibernate(project: any, token: any, successCallback?: Function, errorCallback?: Function) {
    this.httpService.$http({
      method: 'PUT',
      url: `${this.configService.getServerBaseUrl()}/project/${project.id}/hibernate`,
      data: {token: token}
    }).success(response => successCallback?.call(this, response)).error(() => errorCallback?.call(this));
  }

  public SetCurrentProject(project: any) {
    this.currentProject = project;
    if (project.status === Status.Active) {
      this.configService.setFullViewMode("direct");
    } else {
      this.configService.setFullViewMode("local");
    }

    this.rootScope.$broadcast("ProjectService.CurrentProjectChanged", this.currentProject);
  }

  public ClearCurrentProject() {
    this.currentProject = null;
    this.rootScope.$broadcast("ProjectService.CurrentProjectChanged", this.currentProject);
    // Collections are nested inside projects — never want a project cleared with a stale collection left selected.
    this.collectionService.ClearCurrentCollection();
  }

    public GetCurrentProject() {
      return this.currentProject;
    }

    public FindOneOrCurrentProject(query: any, cachingEnabled: boolean = true) {
      // Check if we have this project cached and caching is enabled; if so, return it immediately
      // while still refreshing in the background.
      if (cachingEnabled && this.currentProject && this.currentProject.id === query.id) {
        // Return cached project immediately, but still fetch fresh data
        this.FindOne(query, true);
        return Promise.resolve(this.currentProject);
      }

      // No cache or caching disabled, fetch normally (respecting cachingEnabled for the service-level cache)
      return this.FindOne(query, cachingEnabled);
    }

  public RefreshProjects(callback?: Function) {
    this.ClearCurrentProject();
    callback?.call(this);
  }

  public Delete(project: any, token: string, successCallback?: Function, errorCallback?: Function) {
    this.httpService.$http({
      method: 'DELETE',
      url: `${this.configService.getServerBaseUrl()}/project/${project.id}`,
      data: {token: token}
    }).success(response => successCallback?.call(this, response)).error(response => errorCallback?.call(response));
  }

  public Reactivate(project: any, token, successCallback?: Function, errorCallback?: Function) {
    this.httpService.$http({
      method: 'PUT',
      url: `${this.configService.getServerBaseUrl()}/project/${project.id}/reactivate`,
      data: {token: token}
    }).success(response => successCallback?.call(this, response)).error(response => errorCallback?.call(this, response));
  }

  public SetReviewDateRange(project: any, begin: Date, end: Date) {
    const beginDateTime = moment.tz(moment(begin), moment.tz.utc);
    const endDateTime = moment.tz(moment(end), moment.tz.utc);

    return this.httpService.$http({
      method: 'PUT',
      url: `${this.configService.getServerBaseUrl()}/project/${project.id}/review/begin/${beginDateTime.format("YYYY-MM-DDThh:mm:ssZ")}/end/${endDateTime.format("YYYY-MM-DDThh:mm:ssZ")}`
    });
  }

  public GetTimeZoneIds() {
    let url = `${this.configService.getServerBaseUrl()}/project/timezones`;

    return this.httpService.$http({
      method: 'GET',
      url: url,
      data: ''
    });
  }

  public GetSftpPassword(project: any, successCallback?: Function, errorCallback?: Function, finallyCallback?: Function) {
    this.httpService.$http({
      method: 'GET',
      url: `${this.configService.getServerBaseUrl()}/project/${project.id}/sftp/password`
    })
      .then(response => {
        successCallback?.call(this, response.data);
      })
      .catch(error => {
        errorCallback?.call(this, error);
      })
      .finally(() => {
        finallyCallback?.call(this);
      });
  }

  public async UpdateProject(project: any) {
    return (this.AsResource(project) as any).$update();
  }
}

frontendApp.factory("ProjectService", ['$resource', '$rootScope', 'ConfigService', 'ResourceWrapperService', 'HttpService', 'CollectionService', function(resource, rootScope, configService, resourceWrapperService, httpService, collectionService) {
  return new ProjectService(resource, rootScope, configService, resourceWrapperService, httpService, collectionService);
}]);
